<div style="padding: 20px;" class="save-line">
    <span class="save-line-head" i18n="integrazioni dialog">Integrazioni</span>
</div>
<div>
  <mat-divider class="divider-integration" style="flex: 1 1 auto; margin-right: 25px;"></mat-divider>
</div>
<div>
    <mat-dialog-content>
        <app-tabs-code-example [data]='tabsData'></app-tabs-code-example>
    </mat-dialog-content>
</div>
